'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/routing';

// Re-runs the server component when the app regains focus, so server-rendered
// pages (column locks, market quotes) reflect fresh state right after the
// member switches back — e.g. from the LINE support chat where an admin just
// granted them permissions. Renders nothing.
export default function RefreshOnFocus() {
  const router = useRouter();
  useEffect(() => {
    let last = 0;
    const onFocus = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - last < 5000) return; // debounce focus+visibility double-fire
      last = now;
      router.refresh();
    };
    document.addEventListener('visibilitychange', onFocus);
    window.addEventListener('focus', onFocus);
    return () => {
      document.removeEventListener('visibilitychange', onFocus);
      window.removeEventListener('focus', onFocus);
    };
  }, [router]);
  return null;
}
